module.exports = __webpack_public_path__ + "img/ie-circle.30f19dd0.svg";